import Message from "./Message";
$(document).on('ready', () => {

    var submit = $('#contact-submit-button'),
        form   = $('#contact-form'),
        successMessage = $('#success-message'),
        onlineFormFields = $('.online-form-fields');

    submit.on('click', function(e){
        e.preventDefault();
        let data = new FormData(document.getElementById('contact-form'));

        $.ajax({
            url: '/contact',
            method: 'POST',
            data: data,
            dataType: 'JSON',
            cache: false,
            contentType: false,
            processData: false,
            success: function(data) {

                // Check what type of message will be used
                let type = (data.success) ? 'success' : 'error';

                if(data.success == false){
                    // Sets valid input fields border to none
                    $.each(data.inputs, function (key, value) {
                        $('input[name="' + key + '"]').removeClass('error');
                    });

                    // Checks for inputs with errors and add red border
                    if(data.errors) {
                        $.each(data.errors, function (key, value) {
                            $('input[name="' + key + '"]').addClass('error');
                        });
                    }
                } else {
                    new Message(data.message, type);
                    form.fadeOut(1000).css('display', 'none');
                    successMessage.fadeIn(1000).css('display', 'flex');
                }

            },
            error: function(data) {
                new Message(data.message, 'error');
            }
        });


    });

    /*
    * Toggles contact form on contact buttons
    * */
    $('.contact-btn').on('click', function (e) {

        // Check if contact form button is clicked or online form button
            let isOnlineForm = $(this).hasClass('online') ? true : false,
                contactFormHeader = $('.contact-form-header'),
                onlineFormHeader   = $('.online-form-header');

        // Hide online form fields on default and display online form fields if online form button is clicked
        onlineFormFields.css('display', 'none');
        onlineFormHeader.css('display', 'none');
        contactFormHeader.css('display', 'block');
        if(isOnlineForm) {
            onlineFormFields.css('display', 'block');
            contactFormHeader.css('display', 'none');
            onlineFormHeader.css('display', 'block');
        }

        $('.panel-wrap').toggleClass('open-contact-form', 'close-contact-form');

        let contactFormType = $(this).attr('data-staff-first-name'),
            staffEmail      = $(this).attr('data-staff-email');

        /*
        * Check for data-first-name value whether to display general
        * contact form or staff specific contact form
        * */
        if(contactFormType) {
            // Show title for general contact form
            $('#general-contact').css('display', 'none');
            $('#specific-contact').css('display', 'block');
            $('#contact-staff-title').text('Contact ' + contactFormType);

            // Assign hidden input in form the staff email to be email
            $('#contact-form-type').val(staffEmail);
        } else {
            // Show title for specific contact form
            $('#specific-contact').css('display', 'none');
            $('#general-contact').css('display', 'block');
        }
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/ContactForm.js